module.exports = __webpack_public_path__ + "media/components/src/assets/images/shopping_cart/shopping_cart_black_24dp-99495d8625bcb72c88e011b0f3fd007f.svg";